import { Link } from "@/components/common/Link";
import { Linkedin, Mail } from "lucide-react";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Button } from "@/components/ui/button";
const profiles = [{
  id: 1,
  name: "Hânia Ribeiro",
  title: "SÓCIO FUNDADOR",
  bio: "Especialista em posicionamento estratégico orientado ao propósito, cultura organizacional e desenvolvimento de lideranças. Diretora-fundadora da HAGARI, possui mais de 20 anos de experiência em grandes organizações como Grupo Accor, Votorantim e Sabesp, atuando em estratégia, comunicação, sustentabilidade e desenvolvimento humano.",
  image: "https://masterproplus.com.br/wp-content/uploads/2026/05/Hania-Ribeiro-1.png?v=ph9fvkyg8j",
  imageSrcset: "https://masterproplus.com.br/wp-content/uploads/2026/05/Hania-Ribeiro-1.png?v=scdjw712jlb",
  imageSizes: "https://masterproplus.com.br/wp-content/uploads/2026/05/Hania-Ribeiro-1.png?v=97uwx8qpugo",
  linkedin: "https://www.linkedin.com/in/haniaribeiro/",
  email: "mailto:carlos@masterproplus.com"
}, {
  id: 2,
  name: "Márcio Lario",
  title: "SÓCIO FUNDADOR",
  bio: "Executivo com experiência internacional em liderança C-Level, inovação e desenvolvimento estratégico. Atua como mentor de executivos, conselheiro consultivo e especialista em Inteligência Artificial, transformação organizacional e ecossistemas de inovação.",
  image: "https://masterproplus.com.br/wp-content/uploads/2026/05/Foto-Profissional-MCL-Master2.jpg?v=lrzfzi1fd9n",
  imageSrcset: "https://masterproplus.com.br/wp-content/uploads/2026/05/Foto-Profissional-MCL-Master2.jpg?v=jd3fbzuc26j",
  imageSizes: "https://masterproplus.com.br/wp-content/uploads/2026/05/Foto-Profissional-MCL-Master2.jpg?v=3qctkit31df",
  linkedin: "https://www.linkedin.com/in/marciolario/",
  email: "mailto:mariana@masterproplus.com"
}, {
  id: 3,
  name: "Uilson Fernandes",
  title: "SÓCIO FUNDADOR",
  bio: "Executivo com mais de 22 anos de experiência em grandes multinacionais como Unilever e Nestlé. Especialista em gestão executiva, recursos humanos e desenvolvimento de carreira, com atuação voltada à construção de relevância profissional e novas oportunidades para líderes e executivos.",
  image: "https://masterproplus.com.br/wp-content/uploads/2026/05/foto_profissional_fundo_madeira.png?v=oru1c90ppq",
  imageSrcset: "https://masterproplus.com.br/wp-content/uploads/2026/05/foto_profissional_fundo_madeira.png?v=hw85l7y1buq",
  imageSizes: "https://masterproplus.com.br/wp-content/uploads/2026/05/foto_profissional_fundo_madeira.png?v=6riovsjgjca",
  linkedin: "https://www.linkedin.com/in/uilsonfernandes2/",
  email: "mailto:roberto@masterproplus.com"
}];
export default function PartnersAndExperts() {
  return <section id="partnersandexperts" className="bg-background py-24 lg:py-32 overflow-hidden">
      <div className="container mx-auto px-6 max-w-7xl">
        <div className="mb-20 lg:mb-32 text-center">
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold text-foreground tracking-tight">
            Sócios e Especialistas
          </h2>
          <div className="w-24 h-1 bg-primary mx-auto mt-8"></div>
        </div>

        <div className="flex flex-col gap-24 lg:gap-40">
          {profiles.map((profile, i) => <div key={profile.id} data-index={i} className={`flex flex-col ${i % 2 !== 0 ? 'lg:flex-row-reverse' : 'lg:flex-row'} gap-12 lg:gap-24 items-center`}>
              <div className="w-full lg:w-5/12 shrink-0">
                <div className="p-3 bg-muted/30 border border-border/50">
                  <AspectRatio ratio={3 / 4}>
                    <img src={profile.image} data-wvc-srcset={profile.imageSrcset} data-wvc-sizes={profile.imageSizes} alt={`Retrato de ${profile.name}`} className="object-cover w-full h-full grayscale hover:grayscale-0 transition-all duration-700 ease-in-out" loading="lazy" />
                  </AspectRatio>
                </div>
              </div>
              
              <div className="w-full lg:w-7/12 flex flex-col justify-center">
                <h3 className="font-serif text-3xl md:text-4xl lg:text-5xl font-bold text-foreground tracking-tight">
                  {profile.name}
                </h3>
                <p className="font-default text-sm md:text-base uppercase tracking-widest text-primary mt-4 font-semibold">
                  {profile.title}
                </p>
                
                <p className="font-default font-normal text-lg md:text-xl leading-relaxed text-muted-foreground mt-8 lg:mt-10">
                  {profile.bio}
                </p>
                
                <div className="flex justify-end gap-3 mt-12 lg:mt-16">
                  <Button variant="outline" size="icon" asChild className="rounded-none border-border hover:bg-primary hover:text-primary-foreground hover:border-primary transition-colors">
                    <Link to={profile.linkedin} newTab aria-label={`Perfil do LinkedIn de ${profile.name}`}>
                      <Linkedin className="w-4 h-4" />
                    </Link>
                  </Button>
                  <Button variant="outline" size="icon" asChild className="rounded-none border-border hover:bg-primary hover:text-primary-foreground hover:border-primary transition-colors">
                    
                  </Button>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}